import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationVaultResponseCodes = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
